module.exports = __webpack_public_path__ + "static/img/91BM-065-JingSun.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-065-JingSun.jpg
// module id = s359
// module chunks = 0